// Split as per usual if there is ever a second action here
export const LOGOUT = 'app/Logout/LOGOUT';

export const logout = () => ({
  type: LOGOUT,
});
